import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { routes } from '../../utils/ESPRoutes';
import Navbar from '../../common/Navbar/Navbar';
import Sidebar from 'react-sidebar';
import ESPSidebarContent from '../../common/SidebarContent/ESPSidebarContent';
import { getESPUser } from '../../utils/localStorage';
import ESPNavbar from './ESPNavbar';
import "../../styles/global.scss";

class ESPHome extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isSidebarOpen : false,
        Pagetitle:""
      }
    }
  
    checkPageTitle = (title) => 
    {
      if(title==="/service_partner/dashboard/"||title==="/service_partner/dashboard")
      {
        this.setState({Pagetitle : "Dashboard"});
      }
      else if(title==="/service_partner/service-requests/"||title==="/service_partner/service-requests")
      {
        this.setState({Pagetitle : "Service Requests"});
      } 
      else if(title==="/service_partner/reports/"||title==="/service_partner/reports")
      {
        this.setState({Pagetitle : "Reports"});
      } 
      else if(title==="/service_partner/upload-status-progression-sheet/"||title==="/service_partner/upload-status-progression-sheet")
      {
        this.setState({Pagetitle : "Upload Status Progression Sheet"});
      }
      else if(title==="/service_partner/follow-ups/"||title==="/service_partner/follow-ups")
      {
        this.setState({Pagetitle : "Follow Ups"});
      }     
      else if(title==="/service_partner/espsubscriber/"||title==="/service_partner/espsubscriber")
      {
        this.setState({Pagetitle : "Prime Subscribers"});
      } 
      else if(title==="/service_partner/espumcinterface/"||title==="/service_partner/espumcinterface")
      {
        this.setState({Pagetitle : "Bulk Services Management"});
      }  
      else if(title==="/service_partner/espumcreporting/"||title==="/service_partner/espumcreporting")
      {
        this.setState({Pagetitle : "UMC Customers"});
      } 
      else if(title ==="/service_partner/espumcfeedback/" || title ==="/service_partner/espumcfeedback")
      {
        this.setState({Pagetitle : "UMC Feedbacks"});
      }    
      else 
      {
        this.setState({Pagetitle : ""});
      }
    }
  
    changePageTitle = (title) => {
      const {Pagetitle} = this.state;
      this.setState({Pagetitle : title});
    }
  
    componentDidMount() {
      const user = getESPUser();
      if(!user) this.props.history.push('/service_partner/login');
  
      this.props.history.listen(() => {
        this.checkPageTitle(window.location.pathname);
      })
      this.checkPageTitle(this.props.history.location.pathname);
    }
    toggleSidebar = () => {
      const {isSidebarOpen} = this.state;
      this.setState({isSidebarOpen : !isSidebarOpen});
    }
  
    render() {
      return(
        <div className=''>
          <ESPNavbar toggleSidebar={this.toggleSidebar} {...this.props} Pagetitle={this.state.Pagetitle}/>
          <Sidebar
            sidebar={<ESPSidebarContent toggleSidebar={this.toggleSidebar} changePageTitle={this.changePageTitle}/>}
            open={this.state.isSidebarOpen}
            onSetOpen={this.toggleSidebar}
            styles={{ sidebar: { background: "white",zIndex:"5"} ,overlay:{zIndex:"4"}}}
            pullRight
          >
            <div className="container-fluid under-nav min-vh-100" style={{backgroundColor:"#FFFFFF"}}>
              <div className="row">
                <div className="col-12">
                  <Switch>
                    {
                      routes.map((route,i) => {
                        const Component = route.component;
                        return(
                          <Route
                            key={i}
                            exact
                            path={route.path}
                            component={Component}
                          />
                        )
                      })
                    }
                    <Route
                      path="/home"
                      render={() => <Redirect to={routes[0].path}/>}
                    />
                  </Switch>
                </div>
              </div>
            </div>
          </Sidebar>
        </div>
      );
    }
  }
  
  export default ESPHome;